const items = [
  "Intervento Rapido", "Roma", "Lavori Edili", "Tinteggiature",
  "Rifacimento Bagni", "Muratura", "Cartongesso", "Piastrellatura",
];

export default function Marquee() {
  const loop = [...items, ...items];
  return (
    <div className="bg-navy text-white py-4 sm:py-5 overflow-hidden marquee-mask relative">
      <div className="noise-overlay" />
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {loop.map((t, i) => (
          <span key={i} className="mx-6 sm:mx-9 inline-flex items-center gap-6 sm:gap-9 text-lg sm:text-2xl font-display font-semibold tracking-tight">
            {t}
            <span className="h-1.5 w-1.5 rounded-full bg-brand-orange" />
          </span>
        ))}
      </div>
    </div>
  );
}
